import React from 'react';
import SearchArticleListBlock from '../platformui/SearchArticleList';

export default (props) => <SearchArticleListBlock {...props} masonryLayout = {props.SearchResult.SearchHits.length === 1 ? false : true}/>;

